import styled from 'styled-components';

export default styled.div`
  color: #f4111b;
  text-align: center;
  width: 100%;
  font-family: var(--font-geomanist);
  font-weight: 200;
  font-size: 12px;
  line-height: 100%;
  letter-spacing: 0;
`;
